module.exports = __webpack_public_path__ + "static/img/member-3.06df1a84.jpg";